import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth";

import Divider from "../layout/Divider.js";
import Space from "../layout/Space";

import PrimaryButton from "../buttons/PrimaryButton";
import { useSnackbar } from "notistack";
import SmallSpinner from "../loading/SmallSpinner.js";
import { useAppContext } from "../config/AppContext.js";
import {
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";
import Modal1 from "../modals/Modal1.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import SecondaryButton from "../buttons/SecondaryButton";

import Icon1 from "../icons/Icon.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import type { User as FirebaseUser } from "firebase/auth";

import createDocApi from "../api/database/createDocApi.js";

import TextField2T from "../textfields/TextField2T";
import DropDownGPT03 from "../dropdowns/DropDownGTP03";
import Gleap from "gleap";
import { ToggleSettingsBrick } from "../textfields/EasySwitch.js";
import createNewPartner from "../api/create/createNewPartner.js";
import { Spin } from "antd";
import { checkPageAccessV2 } from "../auth/checkPageAccess.js";
import { getOrgById } from "../models/OrgFunctions.js";
import { User } from "../types/user";
import { Org, Workspace } from "../types/org";
import { useParams } from "react-router-dom";
import updateDocApi from "../api/database/updateDocApi";

type ModifyPartnerProps = {
  userData: User; // Replace 'any' with the correct type if available
  orgData: Org; // Replace 'any' with the correct type if available
  navigateWorkspace: (path: string) => void;
  workspaceData: Workspace | null; // Replace 'any' with the correct type if available
};

function ModifyPartner({
  userData,
  orgData,
  navigateWorkspace,
  workspaceData,
}: ModifyPartnerProps) {
  const { currentUser, loading } = useAuth() as {
    currentUser: FirebaseUser | null;
    loading: boolean;
  }; // add types
  const { id } = useParams<{ id: string }>();
  const [partner_exists, setParnterExists] = useState<any>(false);
  const [partner_open, setPartnerOpen] = useState(false);
  const type_options = [
    { value: "constructor", label: "Constructeur" },
    { value: "promotor", label: "Promoteur" },
    {
      label: "Artisans",
      id: "artisan",
    },
    { value: "architect", label: "Architecte" },
    { value: "mdo", label: "Maître d'oeuvre" },
    { value: "drawer", label: "Dessinateur" },
    { value: "expert", label: "Bureau d'étude" },
    { value: "infiltro", label: "Infiltromètre" },
    { value: "other", label: "Autre" },
  ];

  const [partnerData, setPartnerData] = useState<Org | null>(null);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (
    message: string,
    variant: "success" | "error" | "default" | "warning" | "info" | undefined
  ) => {
    enqueueSnackbar(message, { variant });
  };

  // State variables to store the input values

  const [payment_allowed, setPaymentAllowed] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [partner_type, setPartnerType] = useState(null);
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (currentUser) {
      try {
        if (id) {
          const partner = (await getDocDataById("org", id)) as Org;
          if (partner) {
            setPartnerData(partner);
          }
        }
        // Fetch user data
        // Fetch organization data using user's org reference
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const [new_partner_user_id, setNew_partner_id] = useState("");
  const [invite_open, setInviteOpen] = useState(false);
  useEffect(() => {
    if (currentUser) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [currentUser]); // Dependency array ensures this runs when currentUser changes

  const handlesendInvite = async () => {
    let new_user = (await getDocDataById("user", new_partner_user_id)) as User;
    let org = (await getOrgById(new_user.org_id)) as Org;
    if (org.invite !== "accepted") {
      await updateDocDataFieldApi(org.ref, "invite", "sent", prefix);
    }
    // await sendInvite(
    //   new_partner_user_id,
    //   orgData.name,
    //   new_user.email,
    //   org.id,
    //   token,
    //   prefix
    // ); // Call the sendInvite API
    handleClickVariant("Invitation envoyée avec succès", "success");
    navigateWorkspace("/partner/" + org.id);
  };

  // Function to create a new client
  const createPartner = async () => {
    if (!userData || !orgData) return;

    try {
      setLoadingData(true); // Set loading state to true
      const oid = orgData.id; // Assuming orgData has the organization id

      // Get the user's Firebase authentication token
      if (!currentUser) {
        handleClickVariant("Utilisateur non authentifié", "error");
        setLoadingData(false);
        return;
      }
      if (!partnerData) return;

      await updateDocApi("org", partnerData.ref, partnerData, prefix); // Update the partner data in Firestore

      handleClickVariant("Partenaire modifié avec succès", "success");
      navigateWorkspace("/partner/" + partnerData.id);
    } catch (error) {
      console.error("Error creating partner:", error);
    }
  };

  if (loading || !currentUser || !userData || !partnerData) {
    return (
      <div className="h-full w-c400 pl-4 flex flex-col gap-2">
        <SmallSpinner />
      </div>
    );
  }

  return (
    <div className="flex-row w-full h-full overflow-auto flex gap-10 pb-20">
      <Modal1
        isOpen={invite_open}
        onClose={() => {
          setInviteOpen(false);
        }}
      >
        {" "}
        <div className="bg-white flex flex-col p-4 w-c300 rounded-3xl  ">
          <div className="flex flex-col gap-3 w-full">
            <div className="flex flex-row justify-between">
              {" "}
              <div className="text-h3 text-shadow_50">
                Envoyer une invitation au client par email pour se connecter sur
                son espace
              </div>
            </div>
            <div className="flex flex-row gap-2 justify-between">
              <SecondaryButton
                className="w-full"
                onClick={() => {
                  setInviteOpen(false);
                  navigateWorkspace("/partner/" + new_partner_user_id);
                }}
              >
                Annuler
              </SecondaryButton>{" "}
              <PrimaryButton className="w-full" onClick={handlesendInvite}>
                Envoyer
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Modal1>
      <Modal1
        isOpen={partner_open}
        onClose={() => {
          setPartnerOpen(false);
        }}
      >
        {" "}
        <div className="bg-white flex flex-col p-4 w-c500 rounded-3xl  ">
          <div className="flex flex-col gap-3 w-full">
            <div className="flex flex-col ">
              {" "}
              <div className="text-h3 text-black">
                Cette entreprise existe déjà dans notre base de données
              </div>
              <div className="flex flex-row gap-4 my-4  rounded-lg p-2 bg-neutral-50 border-1 border-shadow_25">
                <div className="text-h3 text-shadow_50">
                  <img
                    src={partner_exists?.logo}
                    className="w-16 h-16 rounded-lg object-contain"
                  ></img>
                </div>{" "}
                <div className="flex flex-col">
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.name}
                  </div>
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.email}
                  </div>
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.infos?.ville}
                  </div>
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.infos?.postal}
                  </div>{" "}
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.infos?.phone}
                  </div>{" "}
                </div>
              </div>
              <div className="text-h3 text-shadow_50">
                Si l'entreprise correspond au partenaire que vous souhaitez
                ajouter, ajoutez le dirctement à votre réseau.
              </div>
            </div>
            <div className="flex flex-row gap-2 justify-end">
              <PrimaryButton onClick={createPartner} disabled={loadingData}>
                <div className="flex flex-row content-center align-middle items-center">
                  Ajouter le partenaire <Space x={5} />
                  <SmallSpinner loading={loadingData} margin={0} size={20} />
                </div>
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Modal1>
      {/* Left Column: Takes all available space */}
      {/* Right Column: Fixed width */}
      <div className="h-fit flex  flex-col max-w-c500 pl-4 pb-20">
        <div className="text-h1 font-semibold">Nouveau partenaire</div>
        <div className="text-h3 text-shadow_50 mt-2">
          Cette interface permet d'ajouter des partenaires qui pourront
          collaborer avec vous sur les carnets d'information du logement
        </div>{" "}
        <div className={"flex flex-col h-fit gap-2  pr-2 mt-4"}>
          <div className={"flex flex-row gap-2 h-fit w-full pr-2"}>
            <DropDownGPT03
              items={type_options as any}
              className="w-full"
              label="Catégorie"
              value={partnerData?.partner_type}
              mandatory={true}
              onChange={(e) => setPartnerType(e.value as any)} // Update state on change
            ></DropDownGPT03>{" "}
          </div>

          <TextField2T
            className="w-full"
            label="Entreprise"
            value={partnerData?.name}
            mandatory={true}
            onChange={(e) =>
              setPartnerData({
                ...partnerData,
                name: e.target.value,
              })
            }
          ></TextField2T>

          <TextField2T
            label="Téléphone"
            value={partnerData?.infos.phone}
            type="phone"
            mandatory={true}
            onChange={(e) =>
              setPartnerData({
                ...partnerData,
                infos: { ...partnerData.infos, phone: e.target.value },
              })
            }
          ></TextField2T>
          <TextField2T
            label="Ville"
            value={partnerData?.infos.ville}
            mandatory={true}
            onChange={(e) =>
              setPartnerData({
                ...partnerData,
                infos: { ...partnerData.infos, ville: e.target.value },
              })
            }
          ></TextField2T>
          <TextField2T
            label="Postal"
            value={partnerData?.infos.postal}
            mandatory={true}
            onChange={(e) =>
              setPartnerData({
                ...partnerData,
                infos: { ...partnerData.infos, postal: e.target.value },
              })
            }
          ></TextField2T>
          <TextField2T
            label="Adresse"
            value={partnerData?.infos.adresse}
            mandatory={true}
            onChange={(e) =>
              setPartnerData({
                ...partnerData,
                infos: { ...partnerData.infos, adresse: e.target.value },
              })
            }
          ></TextField2T>
        </div>
        <Space y={20} />
        <div className="w-full flex flex-row justify-end">
          <PrimaryButton onClick={createPartner} disabled={loadingData}>
            <div className="flex flex-row content-center align-middle items-center">
              Enregistrer les modifications
              <SmallSpinner loading={loadingData} margin={5} size={20} />
            </div>
          </PrimaryButton>
        </div>
      </div>
      <div className="flex flex-col w-c400">
        <Space y={30} />
      </div>
    </div>
  );
}

export default ModifyPartner;
